import { Container, Stack } from "@mui/material"

import MarketOverview from "./components/MarketOverview"
import PoolOverview from "./components/pool-overview"

const View = () => {
  return (
    <Container maxWidth='xl'>
      <Stack direction={{ xs: "column", sm: "column", md: "row" }} gap={2} className='mt-4'>
        <MarketOverview />

        <PoolOverview />
      </Stack>
    </Container>
  )
}

export default View
